var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconTargetgroupCompany24 = function SvgAIconTargetgroupCompany24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44236 9.42517H11.7533C12.2933 9.42517 12.7311 9.8443 12.7311 10.3613V22.0632H2.4646V10.3613C2.4646 9.8443 2.90236 9.42517 3.44236 9.42517Z",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6639 22.0634H21.5305V2.40423C21.5305 1.6287 20.8738 1 20.0638 1H11.264C10.454 1 9.79736 1.6287 9.79736 2.40423V6.61692H11.264",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46664 22.0638H1",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5334 22.0638H23.0001",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79736 3.80811H14.1973",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4646 12.2341H4.66456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33391 22.063H5.40063V19.2545C5.40063 18.479 6.05727 17.8503 6.86727 17.8503C7.67728 17.8503 8.33391 18.479 8.33391 19.2545V22.063Z",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5995 22.0627H15.6663V17.85C15.6663 17.0745 16.3229 16.4458 17.1329 16.4458C17.9429 16.4458 18.5995 17.0745 18.5995 17.85V22.0627Z",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconTargetgroupCompany24 as ReactComponent };
export default "data:image/svg+xml;base64,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";